import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { push } from 'react-router-redux';
import TicketDetails from './ticketDetails';
import { getNSGlobalSettingsPageInfo } from '../../../redux/actions/settings';
import { getCurrentChampion } from '../../../redux/actions/ns/tickets';
import { getChampionChallengerDetails } from '../../../redux/actions/ns/tickets';
import {
  fetchAMLSAlertLevel,
  putAMLSCommonApproveAndRejectTicket
} from '../../../redux/actions/common';
import { withRouter } from 'react-router-dom';

function mapStateToProps(state) {
  return {
    settings: state.settings,
    authentication: state.authentication,
    championChallengerDetails: state.nsTickets?.championChallengerDetails,
    currentChampion: state.nsTickets?.currentChampion,
    approveAndReject: state.amlsCommon?.tickets?.approveAndReject || undefined,
    alertLevels: state.amlsCommon.alertLevelConfigs.data
  };
}

function mapDispatchToProps(dispatch) {
  return {
    apiActions: bindActionCreators(
      {
        navigateTo: (path) => push(path),
        getNSGlobalSettingsPageInfo,
        getCurrentChampion,
        getChampionChallengerDetails,
        putAMLSCommonApproveAndRejectTicket,
        fetchAMLSAlertLevel
      },
      dispatch
    )
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(TicketDetails)
);
